import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import css from './index.scss';
import messages from './messages';
import Button from '../button';
import { DARK } from '../button/variants';
import UserDelete from '../user-delete';
import ConfirmationMessage from '../confirmation-message';
import Modal from '../modal';
import { Warning, Tick } from '../../helpers/icon-dictionary';
import SignInCardsFormats from '../sign-in-cards-formats';

const ClassFooter = ({
    noOfSelectedClassrooms = 0,
    handleOnDownloadStudentsSignInCards,
    isStudentsSignInCardDownloaded,
    handleOnDeleteClassrooms,
    handleOnShowDeleteClassroomsConfirmation,
    deletingClassrooms = false,
    showDeleteClassroomsConfirmation,
    showDeleteClassroomsSuccess,
    handleOnCloseDeleteClassroomsConfirmation,
    handleOnCloseDeleteClassroomsSuccess,
    deletingEmptyClassrooms,
    intl,
    handleOnStudentSignInCards,
    handleOnCancelStudentSignInCards,
    showHideSignInCardModal = false
}) => {
    const loadModalComponent = () => {
        let modalComponent = '';

        if (showDeleteClassroomsConfirmation && deletingEmptyClassrooms) {
            modalComponent = (
                <UserDelete
                    handleOnCancel={() => { handleOnCloseDeleteClassroomsConfirmation(false); }}
                    handleOnOk={handleOnDeleteClassrooms}
                    heading={intl.formatMessage(messages.doYouWishToDeleteClasses)}
                    icon={Warning}
                    isLoading={deletingClassrooms}
                    title={intl.formatMessage(messages.deleteClassesConfirmation)} />
            );
        } else if (showDeleteClassroomsSuccess && deletingEmptyClassrooms) {
            modalComponent = (
                <ConfirmationMessage
                    handleOnCloseModal={() => { handleOnCloseDeleteClassroomsSuccess(noOfSelectedClassrooms); }}
                    icon={Tick}
                    title={intl.formatMessage(messages.youHaveDeleted, { noOfSelectedClassrooms })} />);
        } else if (showHideSignInCardModal) {
            modalComponent = (
                <SignInCardsFormats
                    handleOnCancel={handleOnCancelStudentSignInCards}
                    handleOnDownloadSignInCards={handleOnDownloadStudentsSignInCards}
                    isSignInCardDownloaded={isStudentsSignInCardDownloaded} />);
        }

        return modalComponent;
    };

    const modalView = (
        <Modal show={deletingEmptyClassrooms || showHideSignInCardModal}>
            {loadModalComponent()}
        </Modal>
    );

    return (
        <div className={css.classFooterComponent}>
            <div className={css.buttonContainer}>
                <Button
                    containerClassName={css.downloadSignInCards}
                    disabled={noOfSelectedClassrooms === 0}
                    handleOnClick={handleOnStudentSignInCards}
                    label={intl.formatMessage(messages.downloadSignInCards)}
                    variant={DARK}
                    visible />
                <Button
                    containerClassName={css.footerButton}
                    disabled={noOfSelectedClassrooms === 0}
                    handleOnClick={handleOnShowDeleteClassroomsConfirmation}
                    label={intl.formatMessage(messages.deleteClasses)}
                    loading={deletingClassrooms}
                    loadingLabel={intl.formatMessage(messages.deleting)}
                    variant={DARK}
                    visible />
            </div>
            {
                modalView
            }
        </div>
    );
};

ClassFooter.propTypes = {
    intl: intlShape.isRequired,
    noOfSelectedClassrooms: PropTypes.number,
    handleOnDownloadStudentsSignInCards: PropTypes.func,
    handleOnShowDeleteClassroomsConfirmation: PropTypes.func,
    handleOnDeleteClassrooms: PropTypes.func,
    isStudentsSignInCardDownloaded: PropTypes.bool,
    deletingClassrooms: PropTypes.bool,
    showDeleteClassroomsConfirmation: PropTypes.bool,
    showDeleteClassroomsSuccess: PropTypes.bool,
    handleOnCloseDeleteClassroomsConfirmation: PropTypes.func,
    handleOnCloseDeleteClassroomsSuccess: PropTypes.func,
    deletingEmptyClassrooms: PropTypes.bool,
    handleOnStudentSignInCards: PropTypes.func,
    handleOnCancelStudentSignInCards: PropTypes.func,
    showHideSignInCardModal: PropTypes.bool
};

export default injectIntl(ClassFooter);



// WEBPACK FOOTER //
// ./app/components/class-footer/index.js